import { render, staticRenderFns } from "./ManageReports.vue?vue&type=template&id=149b6a6a&"
import script from "./ManageReports.vue?vue&type=script&lang=js&"
export * from "./ManageReports.vue?vue&type=script&lang=js&"
import style0 from "./ManageReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports